import {AppState} from '@app/context/context';

//обновление состояния таблицы
export interface IEmitReportPercentsUpdate extends Partial<AppState['reports']['percentsConfig']> { };

export function emitReportPercentsUpdate(
    setState: React.Dispatch<React.SetStateAction<AppState>>,
    event: IEmitReportPercentsUpdate
) {
    setState((prevState: AppState) => {
        return {
            ...prevState,
            reports: {
                ...prevState.reports,
                percentsConfig: {
                    ...prevState.reports.percentsConfig,
                    ...event
                }
            }
        };
    });
}